
// src/connects/caht-album.js

import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import actions from '../actions'
import { translate } from 'react-i18next'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import context from '../helpers/context'
import PropTypes from 'prop-types'

export const mapStateToProps = (state, ownProps) => {
  return {
    isFetching: state.chatRooms.isFetching,
    isFetchFailed: state.chatRooms.isFetchFailed,
    images: state.chatRooms.imageItems,
    files: state.chatRooms.fileItems,
    videos: state.chatRooms.videoItems,
    hasMoreImage: state.chatRooms.hasMoreImage,
    hasMoreFile: state.chatRooms.hasMoreFile,
    hasMoreVideo: state.chatRooms.hasMoreVideo,
  }
}

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    willMount: ()=> dispatch(actions.fetchAlbumChatImage(ownProps.chatRoom.chat_room_id, 'image', 0)),
    willUnmount: ()=> dispatch(actions.clearChatAlbum()),
    fetchImage: (props)=>{
      let offset = props.images && props.images.length || 0
      dispatch(actions.fetchAlbumChatImage(ownProps.chatRoom.chat_room_id, 'image', offset))  
    },
    fetchFile: (props)=>{
      let offset = props.files && props.files.length || 0
      dispatch(actions.fetchAlbumChatFile(ownProps.chatRoom.chat_room_id, 'others', offset))  
    },
    fetchVideo: (props)=>{
      let offset = props.videos && props.videos.length || 0
      dispatch(actions.fetchAlbumChatVideo(ownProps.chatRoom.chat_room_id, offset))  
    },
    onChangeTab: (tabIndex, props)=> {
      switch (tabIndex) {
        case 0:　
          if(!props.images) {
            dispatch(actions.fetchAlbumChatImage(ownProps.chatRoom.chat_room_id, 'image', 0))
          }   
          break
        case 1:
          if(!props.videos)
            dispatch(actions.fetchAlbumChatVideo(ownProps.chatRoom.chat_room_id, 0))
          break
        case 2:
          if(!props.files)
            dispatch(actions.fetchAlbumChatFile(ownProps.chatRoom.chat_room_id, 'others', 0))   
          break
      }
    },
  }

}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  ui({
    state: {
      tabIndex: (props)=> props.params && props.params.tabIndex || 0
    }
  }),
  context({ showImagesView: PropTypes.func }),
  lifecycle,
  translate(),
)


// WEBPACK FOOTER //
// ./src/connects/chat-album.js